import { render, staticRenderFns } from "./ExpedienteDetalle.vue?vue&type=template&id=042f28d8"
import script from "./ExpedienteDetalle.vue?vue&type=script&lang=js"
export * from "./ExpedienteDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports